/* eslint-disable */
import { useDroppable } from '@dnd-kit/core';
import { alpha } from '@mui/material';

// Strike slot component for drop targets
const StrikeSlot = ({
  strike,
  expiry,
  xScale,
  height,
  theme,
  isActive,
}: {
  strike: number;
  expiry: number;
  xScale: d3.ScaleLinear<number, number>;
  height: number;
  theme: any;
  isActive: boolean;
}) => {
  const { isOver, setNodeRef } = useDroppable({
    id: `slot-${expiry}-${strike}`,
    data: { type: 'slot', strike, expiry },
  });

  const centerX = xScale(strike);

  return (
    <div
      ref={setNodeRef}
      style={{
        position: 'absolute',
        left: `${centerX}px`,
        width: '6px',
        height: `${height + 120}px`,
        backgroundColor:
          isOver && isActive ? theme.palette.primary.main : 'transparent',
        borderRadius: '3px',
        pointerEvents: 'auto',
        zIndex: 1,
        transition: 'background-color 0.2s ease-in-out',
        opacity: isOver && isActive ? 0.8 : 0,
        boxShadow:
          isOver && isActive
            ? `0 0 12px ${alpha(theme.palette.primary.main, 0.6)}`
            : 'none',
      }}
    />
  );
};

export default StrikeSlot;
